// extracted by mini-css-extract-plugin
export default {"dottedUnderlineSpan":"_2Ti9ZpDu"};